import { useCallback } from "react";
import { Field, useFormikContext } from "formik";
import NumberField from "components/number-field/NumberField";
import { useFormInputHelpers } from "./useFormInputHelpers";

const FormNumberInput = ({
  name,
  onChange,
  shouldHaveErrorBehaviorAfterSubmit,
  helperText,
  decimals,
  className,
  ...props
}) => {
  const { setFieldValue } = useFormikContext();

  const handleChange = useCallback(
    (val) => {
      if (typeof onChange === "function") {
        onChange(val);
      } else {
        setFieldValue(name, val);
      }
    },
    [name, onChange, setFieldValue]
  );

  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
    helperText,
  });

  return (
    <Field
      name={name}
      as={NumberField}
      helperText={finalHelperText}
      isError={shouldDisplayError}
      onChange={handleChange}
      className={className}
      {...props}
    />
  );
};

export default FormNumberInput;
